import React, { useState } from 'react';
import { DropdownItemText } from 'react-bootstrap';
import constant from '../constants/nameParts.json'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Select from 'react-select'

const NUM_GENERATE_NAMES = 10;

export function NameForm() {

	const [numToGenerate, setNumToGenerate] = useState(10);
	const [names, setNames] = useState([]); 
	const [selectedPrefixes, setSelectedPrefixes] = useState([]);
	const [selectedSuffixes, setSelectedSuffixes] = useState([]);

	const prefixes = constant.prefixes.sort().map(prefix => ({ value: prefix, label: prefix}));
	const suffixes = constant.suffixes.sort().map(suffix => ({ value: suffix, label: suffix}))

	function isLoreName(prefix: string, suffix: string) : Boolean { 
		const loreNames = [ 
			"silverpelt", 
			"greenleaf", 
			"leaffall", 
			"moonpool", 
			"moonstone",
			"tallrock",
			"tallpine",
			"owltree",
			"snakerock",
			"snaketongue"
		];
		const combinedName = prefix + suffix;
		return loreNames.includes(combinedName);
	}

	function prefixDoesntFitWithSuffix(prefix: string, suffix: string): Boolean {
		const beamPrefixes = [
			"sun",
			"moon",
			"light",
			"wood"
		]

		return (suffix == "beam") && (!beamPrefixes.includes(prefix)); 
	}

	function isInsult(prefix: string, suffix: string) : Boolean {
		const heartPrefixes = [
			"fox",
			"mouse",
			"rabbit",
			"rat",
			"snake"
		]

		return (suffix == "heart" && heartPrefixes.includes(prefix));
	}

	function isElemental(namePart: string) : Boolean {
		const elementTerms = [
			"ash",
			"ashen",
			"blaze",
			"blizzard",
			"blaze",
			"burn",
			"burnt",
			"burning",
			"cold",
			"dew",
			"dry",
			"ember",
			"fire",
			"flame",
			"fog",
			"foggy",
			"frost",
			"frosted",
			"frozen",
			"hail",
			"ice",
			"rain",
			"rainy",
			"river",
			"sleet",
			"smoke",
			"snow",
			"soot",
			"storm",
			"sun",
			"sunny",
			"warm",
			"water"
		];

		return elementTerms.includes(namePart);
	}

	function prefixTooSimilarToSuffix(prefix: string, suffix: string) : Boolean {
		 return false; 
	}

	function isDoublePlantName(prefix: string, suffix: string) : Boolean { return false; }
	function isDoubleAnimalName(prefix: string, suffix: string) : Boolean { return false; }
	function animalShouldntUseAnimalSuffix(prefix: string, suffix: string) : Boolean { return false; }
	function animalShouldntUseMovementSuffix(prefix: string, suffix: string) : Boolean { return false; }

	function isValidName(prefix: string, suffix: string) {
		return (!((isLoreName(prefix, suffix) ||
			prefixDoesntFitWithSuffix(prefix, suffix) ||
			isInsult(prefix, suffix) ||
			prefixTooSimilarToSuffix(prefix, suffix) ||
			isDoublePlantName(prefix,suffix) ||
			isDoubleAnimalName(prefix, suffix) ||
			animalShouldntUseAnimalSuffix(prefix, suffix) ||
			animalShouldntUseMovementSuffix(prefix, suffix))));
	}

	function selectPrefixes(prefixes: React.FormEvent) {
		setSelectedPrefixes(prefixes.map((prefix) => prefix.value));
	}

	function selectSuffixes(suffixes: React.FormEvent) {
		setSelectedSuffixes(suffixes.map((suffix) => suffix.value));
	}

	function getPrefix(index : Number) : string {
		return (selectedPrefixes.length > 0 ? selectedPrefixes[index % selectedPrefixes.length] : undefined);
	}

	function getSuffix(index : Number) : string {
		return (selectedSuffixes.length > 0 ? selectedSuffixes[index % selectedSuffixes.length] : undefined);
	}

	function generateName(selectedPrefix: string, selectedSuffix: string) : string {
		var validName = false;
		var prefix = "";
		var suffix = "";

		while (!validName) {
			prefix = selectedPrefix ? selectedPrefix : constant.prefixes[Math.floor(Math.random()*constant.prefixes.length)]
			var genName;
			// type safety check - prefix should never be undefined
			if (!prefix) {
				prefix = "ERROR";
			}
			suffix = selectedSuffix ? selectedSuffix : constant.suffixes[Math.floor(Math.random()*constant.suffixes.length)]
			validName = isValidName(prefix, suffix);
		}
		genName = prefix.charAt(0).toUpperCase() + prefix.slice(1) + suffix;
		console.log(genName);
		return genName;
	}

	const generateNames = async (event: React.FormEvent<HTMLFormElement>) => {
		var genNames = Array();
		console.log("SUBMIT");
		event.preventDefault();

		var numGenerated = 0;
		// if prefixes and suffixes are set, then there is a maximum number of combinations available
		var stopForDuplicates = true; 
		var i = 0; // used to keep spinning past options if generating duplicates
		while (numGenerated < numToGenerate && i < numToGenerate) {
			var nextName = generateName(getPrefix(i), getSuffix(i));
			if (!(genNames.includes(nextName))) {
				genNames.push(nextName);
				numGenerated++;
			} else {
				if (!stopForDuplicates) {
					numGenerated++;
				}
			}
			i++;
		}
		setNames(genNames.sort());
	}

	return (
		<>
		<Form onSubmit={generateNames}>
			<Form.Group controlId="namePrefix">
				<Form.Label>Prefix</Form.Label>
				<Select isMulti isClearable options={prefixes} onChange={(e) => selectPrefixes(e)}/>
			</Form.Group>
			<Form.Group controlId="nameSuffix" className="mt-4">
				<Form.Label>Suffix</Form.Label>
				<Select isMulti isClearable options={suffixes} onChange={(e) => selectSuffixes(e)}/>
			</Form.Group>
			<Form.Group controlId="numToGenerate" className="mt-4">
				<Form.Label>Number of names to generate</Form.Label>
				<Form.Control type="text" value={numToGenerate} onChange={(e) => setNumToGenerate(e.target.value)}/>
			</Form.Group>
			<Button type="submit" className="mt-4">Generate Names</Button>
		</Form>

		{ names.length > 0 &&
			<>
				<p>&nbsp;</p>
				<h2>These names may serve you...</h2>
				<hr/>
				<div>
				{ names.map((item: string, index: number) => (
					<p key={index}>{ item }</p>
				))}	
				</div>
			</>
		}
		</>
	)
}
